var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isOpen)?_c('div',{ref:"emojiMenu",staticClass:"new-emoji-menu bg-white",style:([
    _vm.isAbPosition
      ? { top: _vm.topPositions + 'px', left: _vm.leftPositions + 'px' }
      : {},
    _vm.subtaskEditor && { top: '-250px' },
  ])},_vm._l((_vm.getEmoji),function(emoji,i){return _c('span',{key:i,ref:`emoji${i}`,refInFor:true,class:{ selected: i === _vm.index },on:{"click":function($event){return _vm.handleClick(emoji)},"mouseover":function($event){_vm.index = i}}},[_vm._v(_vm._s(emoji.char))])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }